import PropTypes from "prop-types";
import { useState } from "react";
import { useDispatch } from "react-redux";
import TextInput from "@shared/v2/TextInput";
import FieldLabel from "@shared/v2/FieldLabel";
import TextButton from "@shared/v2/TextButton";
import Button from "@shared/v2/Button";
import { CircleInfoSolidV6, PencilSolidV6 } from "@shared/v2/Icomoon";
import CollapsibleWebsiteCard from "../shared/CollapsibleWebsiteCard";
import SeoHelpModal from "../shared/SeoHelpModal";
import EditingSlugsModal from "../shared/EditingSlugsModal";
import { getToken, updatePage } from "../../reducers/websiteReducer/areaPageReducer";
import { useToken, useTokenExpiresAt } from "../../reducers/websiteReducer/areaPageSelectors";
import { isTokenValid } from "./api";

const SeoPanel = ({ data = undefined, setSeoData }) => {
  const dispatch = useDispatch();
  const token = useToken();
  const tokenExpiresAt = useTokenExpiresAt();
  const [seoModalIsOpen, setSeoModalIsOpen] = useState(false);
  const [editSlugModalIsOpen, setEditSlugModalIsOpen] = useState(false);

  return (
    <>
      <CollapsibleWebsiteCard
        title="SEO"
        action={
          <Button schema="tertiary" onClick={() => setSeoModalIsOpen(true)}>
            <CircleInfoSolidV6 size="s" /> Help
          </Button>
        }
      >
        <div className="tw-flex tw-flex-col tw-gap-[24px]">
          <div className="tw-flex tw-flex-col tw-items-start tw-gap-[4px]">
            <FieldLabel label="Slug" />
            <div>{data?.slug}</div>
            <TextButton className="tw-ml-[-6px]" onClick={() => setEditSlugModalIsOpen(true)}>
              Edit <PencilSolidV6 size="s" />
            </TextButton>
          </div>
          <TextInput
            autoComplete="off"
            label="Meta Title"
            placeholder="Set your browser tab text"
            value={data?.seoTitle}
            onChange={(e) =>
              setSeoData({
                ...data,
                seoTitle: e.target.value,
              })
            }
          />
          <TextInput
            label="Meta Description"
            placeholder="Brief summary of your webpage that appears in search results"
            multiline
            rows={5}
            value={data?.seoDescription}
            onChange={(e) =>
              setSeoData({
                ...data,
                seoDescription: e.target.value,
              })
            }
          />
        </div>
      </CollapsibleWebsiteCard>
      <SeoHelpModal open={seoModalIsOpen} onClose={() => setSeoModalIsOpen(false)} />
      <EditingSlugsModal
        open={editSlugModalIsOpen}
        onClose={() => setEditSlugModalIsOpen(false)}
        initialSlug={data?.slug}
        onSave={async (newSlug) => {
          // The area page owns its slug; saving goes through the page PATCH, not the blog's post
          // slice. The modal can sit open past the token's 5 minutes, so refresh before writing.
          if (!isTokenValid(token, tokenExpiresAt)) await dispatch(getToken()).unwrap();
          await dispatch(updatePage({ slug: newSlug, path: `/${newSlug}` })).unwrap();
          setSeoData({ ...data, slug: newSlug, path: `/${newSlug}` });
        }}
      />
    </>
  );
};

SeoPanel.propTypes = {
  data: PropTypes.shape({
    slug: PropTypes.string,
    seoTitle: PropTypes.string,
    seoDescription: PropTypes.string,
  }),
  setSeoData: PropTypes.func.isRequired,
};

export default SeoPanel;
